import { render, staticRenderFns } from "./CreateBlankDocumentModal.vue?vue&type=template&id=0469dc6c&scoped=true&"
import script from "./CreateBlankDocumentModal.vue?vue&type=script&lang=js&"
export * from "./CreateBlankDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0469dc6c",
  null
  
)

export default component.exports